// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Pqbv","right":"styles_right__33MZU"};